const DEFAULT_COUNTRY_CODE = '92';

const formatDateForMessage = (value) => {
  if (!value) {
    return 'N/A';
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(String(value))) {
    const dateOnly = new Date(`${value}T00:00:00`);
    if (Number.isNaN(dateOnly.getTime())) {
      return String(value);
    }
    return dateOnly.toLocaleDateString();
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return String(value);
  }

  return parsed.toLocaleString();
};

export const normalizeWhatsAppNumber = (phone, defaultCountryCode = DEFAULT_COUNTRY_CODE) => {
  if (!phone) {
    return '';
  }

  let normalized = String(phone).trim();

  if (normalized.startsWith('+')) {
    normalized = normalized.slice(1);
  }

  normalized = normalized.replace(/\D/g, '');

  if (normalized.startsWith('00')) {
    normalized = normalized.slice(2);
  }

  if (normalized.startsWith('0')) {
    normalized = `${defaultCountryCode}${normalized.slice(1)}`;
  }

  if (normalized.length === 10) {
    normalized = `${defaultCountryCode}${normalized}`;
  }

  return normalized;
};

export const generateIssueWhatsAppMessage = (issueRecord) => {
  const studentName = issueRecord?.student_name || 'Student';
  const quantity = issueRecord?.quantity ?? 0;
  const equipmentName = issueRecord?.item_name || 'item';
  const issueDate = formatDateForMessage(issueRecord?.issue_date);
  const expectedReturnDate = formatDateForMessage(
    issueRecord?.expected_return_date || issueRecord?.return_date
  );

  return `Assalam o Alaikum ${studentName},\nAap ne ${quantity} ${equipmentName} issue karwaye hain.\nIssue date: ${issueDate}\nExpected return date: ${expectedReturnDate}\nMeherbani karke is item ko waqt par wapas kar dein.\nShukriya.`;
};

export const generateReturnReminderMessage = (issueRecord) => {
  const studentName = issueRecord?.student_name || 'Student';
  const quantity = issueRecord?.quantity ?? 0;
  const equipmentName = issueRecord?.item_name || 'item';
  const expectedReturnRaw = issueRecord?.expected_return_date || issueRecord?.return_date;
  const expectedReturnDate = formatDateForMessage(expectedReturnRaw);
  const parsedExpected = expectedReturnRaw
    ? (/^\d{4}-\d{2}-\d{2}$/.test(String(expectedReturnRaw))
      ? new Date(`${expectedReturnRaw}T23:59:59`)
      : new Date(expectedReturnRaw))
    : null;
  const hasExpectedDate = parsedExpected && !Number.isNaN(parsedExpected.getTime());
  const isLate = hasExpectedDate ? new Date() > parsedExpected : false;

  if (isLate) {
    return `Assalam o Alaikum ${studentName},\nAap ne ${quantity} ${equipmentName} issue karwaye thay, lekin abhi tak return nahi kiye.\nExpected return date thi: ${expectedReturnDate}\nMeherbani karke foran item wapas kar dein.\nShukriya.`;
  }

  return `Assalam o Alaikum ${studentName},\nYeh yaad dehani hai ke aap ne ${quantity} ${equipmentName} issue karwaye hain.\nReturn date: ${expectedReturnDate}\nMeherbani karke waqt par item return kar dein.\nShukriya.`;
};

export const openWhatsApp = (phone, message) => {
  const normalizedPhone = normalizeWhatsAppNumber(phone);

  if (!normalizedPhone) {
    return false;
  }

  const encodedMessage = encodeURIComponent(message || '');
  const whatsappUrl = `https://wa.me/${normalizedPhone}?text=${encodedMessage}`;
  window.open(whatsappUrl, '_blank');
  return true;
};
